{
  "api/v1/customer/inquiries": {
    "response": [
      {
        "id": 96001,
        "status": "pending",
        "platform": "airbnb",
        "platform_conversation_id": null,
        "platform_inquiry_url": null,
        "guest_name": "Lauren Mitchell",
        "address_id": "ADDRESS_ID_1",
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1"
        },
        "check_in_date": "DATE(2,ISO)",
        "check_out_date": "DATE(4,ISO)",
        "expires_at": "DATETIME(1,15:00)",
        "total_adults": 2,
        "total_children": 1,
        "total_infants": 0,
        "total_pets": 0,
        "total_guests": 3,
        "currency": "USD",
        "amounts_breakdown": [
          { "description": "2 nights x $245.00", "amount": 49000 },
          { "description": "Cleaning fee", "amount": 12500 },
          { "description": "Service fee (host)", "amount": -1845 }
        ],
        "available_actions": ["preapprove", "decline"],
        "message": "Hi! We're in town for my daughter's graduation and your place looks perfect. Would an early check-in around noon be possible? We'd love to freshen up before the ceremony."
      },
      {
        "id": 96002,
        "status": "pending",
        "platform": "airbnb",
        "platform_conversation_id": null,
        "platform_inquiry_url": null,
        "guest_name": "Priya Shah",
        "address_id": "ADDRESS_ID_3",
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3"
        },
        "check_in_date": "DATE(3,ISO)",
        "check_out_date": "DATE(6,ISO)",
        "expires_at": "DATETIME(2,10:00)",
        "total_adults": 2,
        "total_children": 0,
        "total_infants": 0,
        "total_pets": 0,
        "total_guests": 2,
        "currency": "USD",
        "amounts_breakdown": [
          { "description": "3 nights x $189.00", "amount": 56700 },
          { "description": "Cleaning fee", "amount": 11000 },
          { "description": "Service fee (host)", "amount": -2031 }
        ],
        "available_actions": ["preapprove", "decline"],
        "message": "My husband and I are celebrating our anniversary. Quick question — is there space to park two cars?"
      },
      {
        "id": 96003,
        "status": "pending",
        "platform": "vrbo",
        "platform_conversation_id": null,
        "platform_inquiry_url": "https://www.vrbo.com/traveler/inbox",
        "guest_name": "Daniel Kovac",
        "address_id": "ADDRESS_ID_2",
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2"
        },
        "check_in_date": "DATE(9,ISO)",
        "check_out_date": "DATE(12,ISO)",
        "expires_at": null,
        "total_adults": 2,
        "total_children": 3,
        "total_infants": 0,
        "total_pets": 1,
        "total_guests": 5,
        "currency": "USD",
        "amounts_breakdown": [
          { "description": "3 nights x $310.00", "amount": 93000 },
          { "description": "Cleaning fee", "amount": 15000 },
          { "description": "Service fee (host)", "amount": -3240 }
        ],
        "available_actions": [],
        "message": "We're a family of five traveling with a small, well-behaved dog. Happy to pay a pet fee if needed!"
      },
      {
        "id": 96004,
        "status": "pending",
        "platform": "tidy",
        "platform_conversation_id": null,
        "platform_inquiry_url": null,
        "guest_name": "Maya Torres",
        "address_id": "ADDRESS_ID_1",
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1"
        },
        "check_in_date": "DATE(5,ISO)",
        "check_out_date": "DATE(8,ISO)",
        "expires_at": "DATETIME(1,12:00)",
        "total_adults": 2,
        "total_children": 0,
        "total_infants": 0,
        "total_pets": 0,
        "total_guests": null,
        "currency": "usd",
        "amounts_breakdown": [
          { "type": "nights_total_amount", "value": 84000 },
          { "type": "security_deposit_amount", "value": 25000 }
        ],
        "total_amount": 109000,
        "available_actions": ["approve", "decline"],
        "pending_requirements": {},
        "guest": {
          "first_name": "Maya",
          "last_name": "Torres",
          "email": "maya.torres@example.com",
          "phone": "+15125550137"
        },
        "card": { "last4": "4242" }
      }
    ]
  },
  "api/v1/customer/inquiries/*": {
    "byPathParam": {
      "96001": {
        "id": 96001,
        "status": "pending",
        "platform": "airbnb",
        "platform_conversation_id": null,
        "platform_inquiry_url": null,
        "guest_name": "Lauren Mitchell",
        "address_id": "ADDRESS_ID_1",
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1"
        },
        "check_in_date": "DATE(2,ISO)",
        "check_out_date": "DATE(4,ISO)",
        "expires_at": "DATETIME(1,15:00)",
        "total_adults": 2,
        "total_children": 1,
        "total_infants": 0,
        "total_pets": 0,
        "total_guests": 3,
        "currency": "USD",
        "amounts_breakdown": [
          { "description": "2 nights x $245.00", "amount": 49000 },
          { "description": "Cleaning fee", "amount": 12500 },
          { "description": "Service fee (host)", "amount": -1845 }
        ],
        "available_actions": ["preapprove", "decline"],
        "message": "Hi! We're in town for my daughter's graduation and your place looks perfect. Would an early check-in around noon be possible? We'd love to freshen up before the ceremony."
      },
      "96002": {
        "id": 96002,
        "status": "pending",
        "platform": "airbnb",
        "platform_conversation_id": null,
        "platform_inquiry_url": null,
        "guest_name": "Priya Shah",
        "address_id": "ADDRESS_ID_3",
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3"
        },
        "check_in_date": "DATE(3,ISO)",
        "check_out_date": "DATE(6,ISO)",
        "expires_at": "DATETIME(2,10:00)",
        "total_adults": 2,
        "total_children": 0,
        "total_infants": 0,
        "total_pets": 0,
        "total_guests": 2,
        "currency": "USD",
        "amounts_breakdown": [
          { "description": "3 nights x $189.00", "amount": 56700 },
          { "description": "Cleaning fee", "amount": 11000 },
          { "description": "Service fee (host)", "amount": -2031 }
        ],
        "available_actions": ["preapprove", "decline"],
        "message": "My husband and I are celebrating our anniversary. Quick question — is there space to park two cars?"
      },
      "96003": {
        "id": 96003,
        "status": "pending",
        "platform": "vrbo",
        "platform_conversation_id": null,
        "platform_inquiry_url": "https://www.vrbo.com/traveler/inbox",
        "guest_name": "Daniel Kovac",
        "address_id": "ADDRESS_ID_2",
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2"
        },
        "check_in_date": "DATE(9,ISO)",
        "check_out_date": "DATE(12,ISO)",
        "expires_at": null,
        "total_adults": 2,
        "total_children": 3,
        "total_infants": 0,
        "total_pets": 1,
        "total_guests": 5,
        "currency": "USD",
        "amounts_breakdown": [
          { "description": "3 nights x $310.00", "amount": 93000 },
          { "description": "Cleaning fee", "amount": 15000 },
          { "description": "Service fee (host)", "amount": -3240 }
        ],
        "available_actions": [],
        "message": "We're a family of five traveling with a small, well-behaved dog. Happy to pay a pet fee if needed!"
      },
      "96004": {
        "id": 96004,
        "status": "pending",
        "platform": "tidy",
        "platform_conversation_id": null,
        "platform_inquiry_url": null,
        "guest_name": "Maya Torres",
        "address_id": "ADDRESS_ID_1",
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1"
        },
        "check_in_date": "DATE(5,ISO)",
        "check_out_date": "DATE(8,ISO)",
        "expires_at": "DATETIME(1,12:00)",
        "total_adults": 2,
        "total_children": 0,
        "total_infants": 0,
        "total_pets": 0,
        "total_guests": null,
        "currency": "usd",
        "amounts_breakdown": [
          { "type": "nights_total_amount", "value": 84000 },
          { "type": "security_deposit_amount", "value": 25000 }
        ],
        "total_amount": 109000,
        "available_actions": ["approve", "decline"],
        "pending_requirements": {},
        "guest": {
          "first_name": "Maya",
          "last_name": "Torres",
          "email": "maya.torres@example.com",
          "phone": "+15125550137"
        },
        "card": { "last4": "4242" }
      }
    }
  }
}
